 $(".more-option").on("mouseover", (function() {
    $(this).addClass("open"), $(".site-nav__submenu").addClass("visible")
})).on("mouseout", (function() {
    $(this).removeClass("open"),$(".site-nav__submenu").removeClass("visible")
}))

 
//  $(".site-nav--has-dropdown").on("mouseover", (function() {
//     $(this).find(".sub-menu").addClass("visible") 
// })).on("mouseout", (function() {
//     $(this).find(".sub-menu").removeClass("visible") 
// }))

 
// $(".site-nav__submenu").on("mouseover", (function() {
//     $(this).parent().addClass("open")
// })).on("mouseout", (function() {
//     $(this).parent().removeClass("open");
//     $(this).removeClass('visible');
   
// }))
 
 


 
  $(window).scroll(function(){
   var mega = $('.site-header');
   scroll = $(window).scrollTop(); 

   if (scroll >= 50)
   {
 
     
     $('#HeaderWrapper').addClass('fixed');
     
     $('.announcement-bar').addClass('slide_u');
     
     $('.toolbar').addClass('slide_u');
     
     mega.addClass('navup');
     
     $('.desktop_logo').hide();
     
     $('.mobile_logo').hide();
     
     $('#logo_scroll').show();

     $('.site-header__logo-link').addClass('scrolling');
     
       $('.header-item--split-left').css({'margin-left': '-25px', 'margin-right': '-25px'});
       $('.header-item--split-right').css({'margin-left': '-25px', 'margin-right': '-25px'});
   }

   else 
   {
       $('.announcement-bar').removeClass('slide_u');
     
     $('.toolbar').removeClass('slide_u');
     
      mega.removeClass('navup');
     
     $('#HeaderWrapper').removeClass('fixed'); 
     
      $('.header-item--split-left').removeAttr( "style" );
      $('.header-item--split-right').removeAttr( "style" );
     
     $('#logo_scroll').hide();
     $('.desktop_logo').show();
     
     $('.mobile_logo').show();
     
    $('.site-header__logo-link').removeClass('scrolling');
   }
 });



  $(function() {
       
    
  $(".add-to-cart").click(function(){
    
  $(this).addClass('btn--loading');  
    
    
    var variant_id = $(this).data('variant-id');
    
   addItemToCart(variant_id, 1)
    
   console.log(variant_id);
});

   
  
  function addItemToCart(variant_id, qty) {
    
    
    data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        
        $(".add-to-cart").removeClass('btn--loading');  
        
        document.dispatchEvent(new CustomEvent('cart:build'));
        
        $("#cart_call")[0].click();
        
      }
    });
  
  }
    
  })
  
  
  
//-------------------product scroll sections--------------------//
  
  $(".product-nav__list li").click(function() {
    
  var link =  $(this).find('a').attr('href');
    
   
    var e = $(link).offset().top;
    
    $('html, body').animate({
   
        scrollTop: e - 80 
      
    }, 2000);
});


//----------------------------Add multiple products-------------------------------------//



$(function(){
      $('.custom-add-to-cart').click(function(){
        
         $(this).addClass('btn--loading');  
        
        if ($('input.add_checkbox').is(':checked')) {
        var val = [];
        $('.add_checkbox:checked').each(function(i){
          val[i] = $(this).val();
          
          console.log($(this).val());
          
          
          
          addAllItems(val);
          
           
          
        });
          
        }
        else
        {
         var product_id = $('.custom-add-to-cart').siblings('.product-single__variants').find("option:selected").val();
          
          addItemToCart(product_id, 1)

          function addItemToCart(variant_id, qty) {


            data = {
              "id": variant_id,
              "quantity": qty
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 

                $(".custom-add-to-cart").removeClass('btn--loading');  

                document.dispatchEvent(new CustomEvent('cart:build'));

                $("#cart_call")[0].click();

              }
            });

          }
     
        }  
        
        
        
      });
  
     
  
    });



      function addAllItems(array){
        Shopify.queue = [];
 
      //  var quantity = {{ cart.item_count }} ;
      
    //  var newArray = array.split(',');
        
        var newArray = array;

      for (var i = 0; i < newArray.length; i++) {
        product = newArray[i]
        Shopify.queue.push({
          variantId: product,
        });
      }
      Shopify.moveAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          var data = 'id='+ request.variantId + '&quantity=1'
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(res){
              Shopify.moveAlong();
            //  quantity += 1;
            },
            error: function(){
              // if it's not last one Move Along else update the cart number with the current quantity
              if (Shopify.queue.length){
                Shopify.moveAlong()
              } else {
               // $('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>");
                
                console.log('Error in Prodcut adding');
              }
            }
          });
        }
        // If the queue is empty, we add 1 to cart
        else {
          console.log(' 1 product adding');
          
         addCurrenctProduct();
          
          $('.custom-add-to-cart').removeClass('btn--loading'); 
          
          
          document.dispatchEvent(new CustomEvent('cart:build'));

          $("#cart_call")[0].click();
             
        }
      };
      Shopify.moveAlong();
       
        
    };



function addCurrenctProduct(){

  var product_id = $('.custom-add-to-cart').siblings('.product-single__variants').find("option:selected").val();
          
          
        

          console.log(product_id);
          
         var  arr = {
              "id": product_id,
              "quantity": 1
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: arr,
              dataType: 'json',
              success: function() { 

               document.dispatchEvent(new CustomEvent('cart:build'));

              }
            });

          
}



//-------------------------------------------------------//


$(" .slick-prev , .slick-next").click(function() {
    
     $('.additional-item').hide();
    
    $('.slider-preview').show();
  
  console.log('fffasfdsf');
    
  })

  $(".slider-thumb li").click(function() {
    
     $('.additional-item').hide();
    
    $('.original-item ').show();
    
  })

  $(".add_checkbox").click(function() {
    
  var image_src =  $(this).siblings('img').data('image-src');
    
 
    
    $('.original-item').hide();
    $('.additional-item').hide();
    
    var id = $(this).data('add-id');
    
    console.log('image:'+ id);
    
    $('#additional-item-' + id).show();
    
   
    
//     $('.slick-current .containerZoom').css('background-image', 'url('+ image_src +')');
    
//     $('.slick-current #imageZoom').attr("src", ''+image_src+'');
    

});

//.....................................................//

$(document).ready(function(){
      $('.slider').slick({
        slidesToShow: 5,
        slidesToScroll: 2,
        autoplay: true,
        arrows: true,
        infinite: true
      })
      
        });

//..........................................................//

$(document).ready(function(){
  
      $('#button-5').removeClass('is-open'); 
     
      $('#Linklist-5').removeAttr( "style" );
  
  });

//.....................................................//




$(document).ready(function(){
  
  if ($(window).width() < 768) {

    $('.slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        infinite: true
      })
    
      // $('.mobile-collection-slider').slick({
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   autoplay: true,
      //   arrows: true,
      //   infinite: true
      // })
      
      
      $(".add_checkbox").click(function() {

        var image_src =  $(this).siblings('img').data('image-src');



       

//        var id = $(this).data('add-id');

        console.log( image_src);

    
        $('.additional-item-1').find('img').attr("src", ''+image_src+'');
        
        
      $('.my-gallery').hide();  
      $('.additional-item-1').show();

      $('.additional-item-link').show();  



//              $('.my-gallery .is-selected').find('img').attr("src", ''+image_src+'');
//              $('.my-gallery .is-selected').find('img').attr("srcset", ''+image_src+'');

      });
    
    
    $(".msg_image").click(function() {
      
      $('.my-gallery').show();  
      $('.additional-item-1').hide();
      
      $('.additional-item-link').hide();  
      
      });
      
  }
        });

